import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthHelperService {
  constructor(private _oidcSecurityService: OidcSecurityService) {}

  public hasRole(roles: string[] | string): boolean {
    if (!this._oidcSecurityService.isAuthenticated()) {
      return false;
    }

    const token = this._oidcSecurityService.getAccessToken();
    if (!token) {
      return false;
    }

    const tokenPayloadJSONObject = this.getTokenPayloadJSONObject();

    if (typeof roles === 'string') {
      roles = [roles];
    }

    if (tokenPayloadJSONObject.roles) {
      let ownedRoles =
        typeof tokenPayloadJSONObject.roles === 'string'
          ? [tokenPayloadJSONObject.roles]
          : tokenPayloadJSONObject.roles;

      return roles.some(role => ownedRoles.includes(role));
    }

    return false;
  }

  public hasAtLeastOneTenant(): boolean {
    const tokenPayloadJSONObject = this.getTokenPayloadJSONObject();
    if (tokenPayloadJSONObject.tenants) {
      return tokenPayloadJSONObject.tenants.length > 0;
    }

    return false;
  }

  public isAuthenticated(): boolean {
    return this._oidcSecurityService.isAuthenticated();
  }

  private getTokenPayloadJSONObject() {
    const token = this._oidcSecurityService.getAccessToken();
    if (!token) {
      return undefined;
    }

    const tokenPayload = token.split('.')[1];
    var base64 = tokenPayload.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  public getDisplayName() {
    const tokenPayloadJSONObject = this.getTokenPayloadJSONObject();
    return tokenPayloadJSONObject.name;
  }
}
